/**
 * Persist settings for the IDE/its editor
 */
import _ from 'underscore';
import Backbone from 'backbone';
import Api from '@/lib/api/api';

    var ide_settings = new Backbone.Model({
        // Defaults will be overwritten the first time this is fetched
        tabSize: 4,
        theme: 'idle_fingers',
        ide_orientation : 'vertical',
        new_user : true,
        fullscreen : false,
        timezone : 'UTC',
    });
    _(ide_settings).extend({
        url : function() { return Api.urls.settings(); },
        sync : Api.sync,
        parse: function(data) {
            var real_data;
            // GET returns data.settings;
            // POST returns data.settings.settings.
            // It's weird
            if (data.settings) {
                if (data.settings.settings) {
                    real_data = data.settings.settings;
                } else {
                    real_data = data.settings;
                }
            }
            if (!data.settings) {
                console.error('Expected settings object to have a "settings" key');
                return {};
            }
            return JSON.parse(real_data);
        }
    });
    export default ide_settings;

